import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import T from 'i18n-react'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import ReportHeader from '../ReportHeader'
import ReportHeader2 from '../ReportHeader2'
import SpecTable from 'components/display/SpecTable'
import SpecTableEnterprise from '../SpecTableEnterprise'
import Section from '../ReportSection/index'
import {
  Table,
  TableHead,
  TableRow,
  TableCell
} from 'react-toolbox'
import {
  NVQUAL_GPU_INFO,
  NVQUAL_GPU_INFO_ENTERPRISE,
  NVQUAL_CPU_INFO,
  NVQUAL_PCIE_INFO,
  NVQUAL_SSD_INFO,
  NVQUAL_NETWORK_INFO
} from './constants'
import { ENTERPRISE_NVQUAL_VERSION_PREFIX } from 'containers/NvqualReport/constants'
import TestSummary from './TestSummary'
import TestSummaryEnterprise from './TestSummaryEnterprise'
import CustomerInputsTable from '../CustomerInputsTable'
import { Element } from 'react-scroll'


class ReportSummary extends Component {
  renderTableRows(info, infoKeys) {
    return info.map((info, idx) => (
      <TableRow key={idx}>
        {infoKeys.map((nameInfo, idx2) =>
          <TableCell key={`${idx2}`}>
            {info[nameInfo] !== undefined ? info[nameInfo] : ""}
          </TableCell>
        )}
      </TableRow>
    ))
  }

  renderTableHead(infoKeys, translateKey) {
    return (
      <TableHead key={`header`}>
        {infoKeys.map((info, idx) =>
          <TableCell key={`header${idx}`}>{T.translate(`specs.${translateKey}.${info}`)}</TableCell>)}
      </TableHead>
    )
  }

  nvqualSummary() {
    return {
      pass: this.props.currentRevision.revision.pass ?
        <code className={styles.green}>Completed with no errors</code> :
        <code className={styles.red}>Completed with errors</code>
    }
  }

  isEnterpriseNvQualVersion() {
    const nvqualPackageVersion = _.get(this.props, 'currentRevision.revision.data.nvqualPackageVersion', '')
    return nvqualPackageVersion.indexOf(ENTERPRISE_NVQUAL_VERSION_PREFIX) == 0;
  }

  render() {
    const gpuInfo = _.get(this.props, 'currentRevision.revision.data.gpuInfo', [])
    const cpuInfo = _.get(this.props, 'currentRevision.revision.data.cpuInfo', [])
    const pcieInfo = _.get(this.props, 'currentRevision.revision.data.pcieInfo', [])
    const ssdInfo = _.get(this.props, 'currentRevision.revision.data.ssdInfo', [])
    const networkInfo = _.get(this.props, 'currentRevision.revision.data.networkInfo', [])
    const genericDeviceInfo = _.get(this.props, 'currentRevision.revision.data.genericDeviceInfo', [])
    const { customerInputs } = this.props.currentRevision.revision

    const NVQUAL_GPU_KEYS = this.isEnterpriseNvQualVersion() ? NVQUAL_GPU_INFO_ENTERPRISE : NVQUAL_GPU_INFO

    return (
      <Element name="summary" >
        <Section>
          <ReportHeader title={`NVQual Inspector Review Status`} />
          <Section>
            <SpecTable moduleName='nvqualSummary' moduleData={this.nvqualSummary()} />
          </Section>
          <Section>
            <ReportHeader2 title={`Test Results`} />
            {this.isEnterpriseNvQualVersion() ?
              <TestSummaryEnterprise tests={this.props.currentRevision.tests} /> :
              <TestSummary tests={this.props.currentRevision.tests} />}
          </Section>
        </Section>
        <Section>
          <ReportHeader title={`NVQual Package`} />
          <SpecTable
            moduleName={this.isEnterpriseNvQualVersion() ? 'nvqualInfoHeader' : 'nvqualInfoHeader'}
            moduleData={this.props.currentRevision.revision.data}
          />
        </Section>
        <Section>
          <ReportHeader title={`System Information`} />
          <SpecTable moduleName='nvqualSystemInfo' moduleData={this.props.currentRevision.revision.data} />
        </Section>
        <CustomerInputsTable
          title={'Customer Inputs Overview'}
          titleSize={1}
          customerInputs={customerInputs}
          section={'overview'} />
        <Section>
          <ReportHeader title={`NVIDIA Device Information`} />
          <div className={styles.tableParent} >
            <Table selectable={false} >
              {this.renderTableHead(NVQUAL_GPU_KEYS, 'nvqualGpuInfo')}
              {this.renderTableRows(gpuInfo, NVQUAL_GPU_KEYS)}
            </Table>
          </div>
        </Section>

        {cpuInfo && cpuInfo.length > 0 && <Section>
          <ReportHeader title={`CPU Information`} />
          <div className={styles.tableParent} >
            <Table selectable={false} >
              {this.renderTableHead(NVQUAL_CPU_INFO, 'nvqualCpuInfo')}
              {this.renderTableRows(cpuInfo, NVQUAL_CPU_INFO)}
            </Table>
          </div>
        </Section>}

        {pcieInfo && pcieInfo.length > 0 && <Section>
          <SpecTableEnterprise
            specOrder={NVQUAL_PCIE_INFO}
            specData={pcieInfo}
            title={'PCIE Root Port Information'}
            translateKey={'nvqualPcieInfo'}
          />
        </Section>}

        {genericDeviceInfo && genericDeviceInfo.length > 0 && <Section>
          <SpecTableEnterprise
            specOrder={NVQUAL_NETWORK_INFO}
            specData={genericDeviceInfo}
            title={'PCIE Information'}
            translateKey={'nvqualNetworkInfo'}
          />
        </Section>}

        {networkInfo && networkInfo.length > 0 && <Section>
          <SpecTableEnterprise
            specOrder={NVQUAL_NETWORK_INFO}
            specData={networkInfo}
            title={'Network Information'}
            translateKey={'nvqualNetworkInfo'}
          />
        </Section>}

        {ssdInfo && ssdInfo.length > 0 && <Section>
          <ReportHeader title={`SSD Information`} />
          <div className={styles.tableParent} >
            <Table selectable={false} >
              {this.renderTableHead(NVQUAL_SSD_INFO, 'nvqualSSDInfo')}
              {this.renderTableRows(ssdInfo, NVQUAL_SSD_INFO)}
            </Table>
          </div>
        </Section>}
      </Element>
    )
  }
}

const withStyles = CSSModules(styles)
const enhance = compose(withStyles)
export default enhance(ReportSummary)
